import React from 'react';

import { useShallow } from 'zustand/react/shallow';

import { Backdrop } from '@thefarmersfront/kitchen-mobile';

import { useLoadingStore } from '~/store';

import Spinner from './Spinner';

import styles from './LoadingIndicator.module.scss';

/**
 * @description 로딩 인디케이터 컴포넌트
 * @returns - React.JSX.Element / LoadingIndicator 컴포넌트 반환
 */
const LoadingIndicator = (): React.JSX.Element => {
  const { show, dimmed, zIndex } = useLoadingStore(
    useShallow((state) => ({
      show: state.show,
      dimmed: state.dimmed,
      zIndex: state.zIndex,
    }))
  );

  return (
    <Backdrop className={styles['loading-indicator']} open={show} dimmed={dimmed} zIndex={zIndex}>
      <Spinner />
    </Backdrop>
  );
};

export default LoadingIndicator;
